exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#back-to-top{display:none;position:fixed;bottom:30px;right:30px;font-size:3em;padding:8px 10px;border-radius:10px;background-color:#767676;opacity:.4;color:#fff;border:none;&:hover,&focur{opacity:1}}", ""]);

// exports
